//Создаём сущность, которая создаёт воркер (1 раз!) и держит очередь заданий для него
import Worker from './calc.worker';
import { RequestReceiver, WorkerRequestSender } from './queue-handler';
import { functionsWithAPI } from './api-functions';
export class ThreadedCalculator {
    worker;
    requestSender;
    requestReceiver;
    constructor(api) {
        this.worker = new Worker();
        this.requestSender = new WorkerRequestSender(this.worker);
        this.requestReceiver = new RequestReceiver(this.worker, functionsWithAPI(api));
    }
    postJob(job) {
        const result = this.requestSender.post(job);
        return result;
    }
}
